import 'fancybox';
import { registerComponents } from 'component-utils';
import components from 'core-components';
import 'global';

onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    // Register the components (if applicable).
    if (context instanceof Document && config.registerComponents !== false)
        registerComponents(components);

    // Menu popup toggle.
    const toggle = document.getElementById('toggle');

    toggle.addEventListener('click', () => {
        toggle.classList.toggle('active');
        document.getElementById('menu-navbar').classList.toggle('open');
    });

    document.getElementById('toggle-close').addEventListener('click', () => {
        document.getElementById('menu-navbar').classList.remove('open');
    });

    // Menu images swap on hover.
    // Get all top-level <li> elements.
    const menuItems = document.querySelectorAll('.menu-items > ul > li > a');

    // Get all <img> elements in the .menu-images div.
    const menuImages = document.querySelectorAll('.menu-images img');

    // Loop through each top-level menu item.
    menuItems.forEach((menuItem, index) => {
        // Add mouseover event listener.
        menuItems.forEach((menuItem, index) => {
            menuItem.addEventListener('mouseover', function() {
                // Remove 'active' class from all images.
                menuImages.forEach(img => img.classList.remove('active'));

                // Check if there's a corresponding image for the menu item.
                if (index < menuImages.length) {
                    // If yes, add 'active' class to the corresponding image.
                    menuImages[index].classList.add('active');
                } else {
                    // If no corresponding image, default to the first image.
                    menuImages[0].classList.add('active');
                }
            });
        });
    });

    // Lazy load videos.
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    if ("IntersectionObserver" in window) {
        var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(video) {
                if (video.isIntersecting) {
                    for (var source in video.target.children) {
                        var videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.classList.remove("lazy");
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(function(lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    };

    // Add class sticky to menu on scroll.
    const header = document.getElementById('header');

    window.addEventListener('scroll', () => {
        if (window.scrollY >= 100)
            header.classList.add('sticky-styles');
        else
            header.classList.remove('sticky-styles');
    });

    // Scroll reveal styles.
    const elementsToFadeInUpOnScroll = context.querySelectorAll('.scroll-reveal, .reason');

    if (elementsToFadeInUpOnScroll.length > 0) {
        window.addEventListener('scroll', () => {
            elementsToFadeInUpOnScroll.forEach(element => {
                let positionFromTop = element.getBoundingClientRect().top;

                if (positionFromTop <= window.innerHeight && positionFromTop >= 0)
                    element.classList.add('fade-in-up');
            });
        });
    }

    // Black to white background styles.
    const elementsToChangeOnScroll = context.querySelectorAll('.black-hover-white');

    if (elementsToChangeOnScroll.length > 0) {
        window.addEventListener('scroll', () => {
            elementsToChangeOnScroll.forEach(element => {
                let positionFromBottom = element.getBoundingClientRect().bottom;

                if (positionFromBottom <= window.innerHeight) {
                    element.classList.add('in-view');
                } else {
                    element.classList.remove('in-view');
                }
            });
        });
    }

    // Play vidoes on hover.
    const videoContainers = document.querySelectorAll('.sector, .showcase-item');
    const videos = document.querySelectorAll('.video');

    videoContainers.forEach((videoContainer, index) => {
        const video = videos[index];

        if ('ontouchstart' in window || navigator.maxTouchPoints) {
            videoContainer.addEventListener('touchstart', function() {
                if (video.paused) {
                    video.play();
                    video.currentTime = 0;
                } else {
                    video.pause();
                }
            });
        } else {
            videoContainer.addEventListener('mouseenter', function() {
                video.play();
                video.currentTime = 0;
            });

            videoContainer.addEventListener('mouseleave', function() {
                video.pause();
            });
        }
    });

    // Scroll To
    context.querySelectorAll('.scroll-to').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();

            const href = link.getAttribute('href'); // Use 'link' instead of 'this'.
            const target = context.querySelector(href);

            // Calculate the offsetTop including the offset of all parent elements.
            let offsetTop = target.offsetTop;
            let currentElement = target;

            while (currentElement.offsetParent !== null) {
                currentElement = currentElement.offsetParent;
                offsetTop += currentElement.offsetTop;
            }

            window.scroll({
                top: offsetTop,
                behavior: 'smooth'
            });
        });
    });

    // Back to top.
    context.querySelectorAll('.scroll-to-top').forEach(link => {
        link.addEventListener('click', e => {
            window.scroll({
                top: 0,
                behavior: 'smooth'
            });
        });
    });
}